/* Inline SVG placeholder used when a product has no image yet. */
export default function ProductImage({ product, className = "", contain = true }) {
  if (product?.image) {
    return (
      <img
        src={product.image}
        alt={product.name}
        className={`${contain ? "object-contain" : "object-cover"} w-full h-full ${className}`}
        loading="lazy"
      />
    );
  }

  const model = product?.model_number || product?.short_name || "MKC";
  // Compact label so very long models stay readable.
  const label = model.length > 22 ? model.slice(0, 22) + "…" : model;

  return (
    <div
      role="img"
      aria-label={product?.name || model}
      className={`w-full h-full relative bg-slate-50 flex flex-col items-center justify-center text-slate-700 select-none ${className}`}
    >
      {/* grid pattern */}
      <div
        className="absolute inset-0 opacity-50"
        style={{
          backgroundImage:
            "linear-gradient(rgba(15,23,42,0.06) 1px, transparent 1px), linear-gradient(90deg, rgba(15,23,42,0.06) 1px, transparent 1px)",
          backgroundSize: "24px 24px",
        }}
      />
      {/* center content */}
      <div className="relative z-10 flex flex-col items-center gap-3 px-6 text-center">
        <span className="font-mono-tactical text-[10px] tracking-[0.25em] text-red-600 uppercase">
          // MKC Catalog
        </span>
        <span className="font-display font-black uppercase tracking-tighter text-2xl md:text-3xl text-[#0A1128] break-words">
          {label}
        </span>
        <span className="font-mono-tactical text-[10px] tracking-widest text-slate-500 uppercase">
          Image · on request
        </span>
      </div>
      {/* corner accents */}
      <span className="absolute top-2 left-2 w-3 h-3 border-t-2 border-l-2 border-red-600" />
      <span className="absolute top-2 right-2 w-3 h-3 border-t-2 border-r-2 border-red-600" />
      <span className="absolute bottom-2 left-2 w-3 h-3 border-b-2 border-l-2 border-red-600" />
      <span className="absolute bottom-2 right-2 w-3 h-3 border-b-2 border-r-2 border-red-600" />
    </div>
  );
}
